document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {

        // Default event
        const DEFAULT_EVENT = "d365mktFormSubmitUnidentified";

        // Map of select values to specific event names
        const eventMapRaw = {
            "Application registration": "d365mktFormSubmitApplicationRegistration",
            "Chat": "d365mktFormSubmitChat",
            "Cold contact (inhouse)": "d365mktFormSubmitColdContactInhouse",
            "Cold contact (outsourced)": "d365mktFormSubmitColdContactOutsourced",
            "Cold contact event": "d365mktFormSubmitColdContactEvent",
            "Contact webform": "d365mktFormSubmitContactWebform",
            "Demo request": "d365mktFormSubmitDemoRequest",
            "Email": "d365mktFormSubmitEmail",
            "Employee referral": "d365mktFormSubmitEmployeeReferral",
            "Event": "d365mktFormSubmitEvent",
            "Inbound call": "d365mktFormSubmitInboundCall",
            "Internal request": "d365mktFormSubmitInternalRequest",
            "Journey": "d365mktFormSubmitJourney",
            "Linkedin sponsored form": "d365mktFormSubmitLinkedinSponsoredForm",
            "Other": "d365mktFormSubmitOther",
            "Partner": "d365mktFormSubmitPartner",
            "Project": "d365mktFormSubmitProject",
            "Quote request": "d365mktFormSubmitQuoteRequest",
            "Social media": "d365mktFormSubmitSocialMedia",
            "Subscription": "d365mktFormSubmitSubscription",
            "Tradeshow": "d365mktFormSubmitTradeshow",
            "Training": "d365mktFormSubmitTraining",
            "Web booking": "d365mktFormSubmitWebBooking",
            "Webinar": "d365mktFormSubmitWebinar",
            "Whitepaper download": "d365mktFormSubmitWhitepaperDownload"
        };

        const eventMap = {};
        Object.keys(eventMapRaw).forEach(key => {
            eventMap[key.toLowerCase()] = eventMapRaw[key];
        });

        // Handle Outbound form submissions
        const formBlocks = document.querySelectorAll("div[data-form-block-id]");
        formBlocks.forEach((block) => {
            const forms = block.querySelectorAll("form");
            if (forms.length > 0) {
                forms.forEach((form) => {
                    form.addEventListener("submit", function () {
                        const select = form.querySelector("select");
                        const selectedText = select?.options[select.selectedIndex]?.textContent?.trim() || "Unidentified";
                        const currentEventName = eventMap[selectedText.toLowerCase()] || DEFAULT_EVENT;

                        window.dataLayer = window.dataLayer || [];

                        // Push specific event to dataLayer
                        window.dataLayer.push({
                            event: currentEventName,
                            [currentEventName]: true,
                            LeadSource: selectedText
                        });

                        // Push general fallback event to dataLayer
                        window.dataLayer.push({
                            event: 'd365mktFormSubmitAll',
                            'd365mktFormSubmitAll': true,
                            LeadSource: 'general'
                        });

                        console.log("Lähetys OUTBOUND: dataLayer push:", {
                            event: currentEventName,
                            LeadSource: selectedText
                        });
                    });
                });
            }
        });

        // Listen for RTM form submission via custom event
        document.addEventListener("d365mkt-afterformsubmit", function (e) {
            let selectedText = "Unidentified";
            let currentEventName = DEFAULT_EVENT;

            const closestSelect = e.target?.closest("form")?.querySelector("div[data-targetproperty='leadsourcecode'] select");

            if (closestSelect) {
                selectedText = closestSelect.options[closestSelect.selectedIndex]?.textContent?.trim() || selectedText;
                currentEventName = eventMap[selectedText.toLowerCase()] || DEFAULT_EVENT;
            }

            window.dataLayer = window.dataLayer || [];

            // Push specific event to dataLayer
            window.dataLayer.push({
                event: currentEventName,
                [currentEventName]: true,
                LeadSource: selectedText
            });

            // Push general fallback event to dataLayer
            window.dataLayer.push({
                event: 'd365mktFormSubmitAll',
                'd365mktFormSubmitAll': true,
                LeadSource: 'general'
            });

            console.log("Lähetys RTM: dataLayer push:", {
                event: currentEventName,
                LeadSource: selectedText
            });
        });

    }, 4000); // Delay of 4 seconds to ensure form and select elements are rendered
});
